export default "__VITE_ASSET__$ZBFLgHo__"